import DateInput from "./InputDate";
import TimeInput from "./InputTime";
import SelectParameter from "./SelectParameter";
import MultiSelects from "./MultiSelects";
import { FiMinus, FiPlus } from "react-icons/fi";
import handleChange from "../utils/handleChange";
import { useNavigate } from "react-router-dom";
import Spinner from "./Spinner";


const DashboardMainTable = ({
    selectedFromDate,
    setSelectedFromDate,
    selectedFromTime,
    setSelectedFromTime,
    selectedToDate,
    setSelectedToDate,
    selectedToTime,
    setSelectedToTime,
    handleConfirmRangeChange,
    loadingCharts = false,
    handleResetRangeChange,
    handleSignals,
    location,
    step,
    addAdditionalSelect,
    upperAdditionalSelects,
    setUpperAdditionalSelects,
    removeAdditionalSelect,
    setCurrentDataPointsUpper,
    chartOrder,
    upperChartName,
    setUpperChartName,
    handleAdditionalSelectChange,
    lowerAdditionalSelects,
    setLowerAdditionalSelects,
    setCurrentDataPointsLower,
    lowerChartName,
    setLowerChartName,
    handleOpenMeasurementFolder,
    handleOpenMeasurementNotes,
    handleCheckAverageValues,
    isInitialCheckClicked,
    averageValues,
    loadingAverageCalculation
}) => {

    const navigate = useNavigate();

    const formatNumber = (x) => {
        if (x >= 1) {
            return x.toFixed(4);    
        } else if (x >= 1e-3) {
		  return (x * 1e3).toFixed(4); // mili
		} else if (x >= 1e-6) {
		  return (x * 1e6).toFixed(4); // mikro
		} else if (x >= 1e-9) {
		  return (x * 1e9).toFixed(4); // nano
		} else if (x >= 1e-12) {
		  return (x * 1e12).toFixed(4); // piko
		} else {
		  return x;
		}
    }

    const formatUnit = (u) => {
        if (u >= 1) {
            return '';    
        } else if (u >= 1e-3) {
		  return 'm'; // mili
		} else if (u >= 1e-6) {
		  return 'µ'; // mikro
		} else if (u >= 1e-9) {
		  return 'n'; // nano
		} else if (u >= 1e-12) {
		  return 'p'; // piko
		} else {
		  return '<p';
		}
    }


    return (
        <div className="dashboard-table-buttons-wrapper">
            <div className="dashboard-controls-panel" aria-busy={loadingCharts}>
                <fieldset className="dashboard-controls-fields" disabled={loadingCharts} aria-label="Chart settings">
                <table className="dashboard-table-style">
                    <tbody>
                        <tr>
                            <td className="dashboard-table-style-td">
                                <div className="dashboard-date-time-container">
                                    FROM:
                                    <div className="dashboard-date-time-container">    
                                        <DateInput 
                                            selectedDate={selectedFromDate}
                                            handleSelectedDate={handleChange(setSelectedFromDate)}
                                        />
                                        <TimeInput 
                                            selectedTime={selectedFromTime}
                                            handleSelectedTime={handleChange(setSelectedFromTime)}
                                        /> 
                                    </div>
                                </div>
                                <div className="dashboard-date-time-container">
                                    TO:
                                    <div className="dashboard-date-time-container">
                                        <DateInput 
                                            selectedDate={selectedToDate}
                                            handleSelectedDate={handleChange(setSelectedToDate)}
                                        />
                                        <TimeInput 
                                            selectedTime={selectedToTime}
                                            handleSelectedTime={handleChange(setSelectedToTime)}
                                        />
                                    </div>
                                </div>
                                <button className="dashboard-small-button" onClick={handleConfirmRangeChange} aria-busy={loadingCharts} disabled={loadingCharts}>
                                    Confirm Range Change
                                </button>
                                <button className="dashboard-small-button" onClick={handleResetRangeChange}>Reset Range</button>
                                <button className="dashboard-small-button" onClick={handleSignals}>Go to Nearest Signals</button>
                            </td>
                        </tr>
                        <tr>
                            <td className="dashboard-container-smaller padding-top-dashboard">
                                Location: 
                                <div>
                                    {location.place !== '' && location.place}<br />
                                    {location.thoroughfare !== '' && location.thoroughfare}<br />
                                    {location.type_line !== '' && location.type_line}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="dashboard-container-smaller padding-top-dashboard">
                                Probe step:
                                <div>
                                    {step}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="dashboard-container-small">
                                Upper Chart:
                                <div className="dashboard-buttons-insert-chart-wrapper">
                                    <button className="dashboard-button-add" onClick={() => addAdditionalSelect(upperAdditionalSelects, setUpperAdditionalSelects)}><FiPlus /></button>
                                    <button className="dashboard-button-delete" onClick={() => removeAdditionalSelect(upperAdditionalSelects, setUpperAdditionalSelects, setCurrentDataPointsUpper, "upper")}><FiMinus /></button>
                                </div>
                                <div>
                                    <SelectParameter
                                        Parameters={chartOrder}
                                        selectedParameter={upperChartName}
                                        setSelectedParameter={setUpperChartName}
                                    />
                                    <MultiSelects 
                                        additionalSelects={upperAdditionalSelects}
                                        setAdditionalSelects={setUpperAdditionalSelects}
                                        handleAdditionalSelectChange={handleAdditionalSelectChange}
                                        chartNames={chartOrder}
                                    />               
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="dashboard-container-small">
                                Lower Chart:
                                <div className="dashboard-buttons-insert-chart-wrapper">
                                    <button className="dashboard-button-add" onClick={() => addAdditionalSelect(lowerAdditionalSelects, setLowerAdditionalSelects)}><FiPlus /></button>
                                    <button className="dashboard-button-delete" onClick={() => removeAdditionalSelect(lowerAdditionalSelects, setLowerAdditionalSelects, setCurrentDataPointsLower, "lower")}><FiMinus /></button>
                                </div>
                                <div>
                                    <SelectParameter
                                        Parameters={chartOrder}
                                        selectedParameter={lowerChartName}
                                        setSelectedParameter={setLowerChartName}
                                    />
                                    <MultiSelects 
                                        additionalSelects={lowerAdditionalSelects}
                                        setAdditionalSelects={setLowerAdditionalSelects}
                                        handleAdditionalSelectChange={handleAdditionalSelectChange}
                                        chartNames={chartOrder}
                                    />               
                                </div>
                            </td>
                        </tr>
                    </tbody>                    
                </table>
                </fieldset>
                {loadingCharts && (
                    <div className="dashboard-controls-loading" role="status" aria-label="Loading chart settings">
                        <Spinner decorative />
                    </div>
                )}
            </div>
                {isInitialCheckClicked ? <div className="table-wrapper2"> 
                    {!loadingAverageCalculation? <table className="dashboard-table-style2">
                        <colgroup>
                            <col  style={{width: "30%"}}/>
                            <col  style={{width: "30%"}}/>
                            <col  style={{width: "40%"}}/>
                        </colgroup>
                        <tbody>
                            <tr>
                                <td>interval</td>
                                <td>{averageValues.interval.value && formatNumber(averageValues.interval.value)}</td>
                                <td>[{averageValues.interval.value && formatUnit(averageValues.interval.value)}s]</td>
                            </tr>
                            <tr>
                                <td>vol of fluid</td>
                                <td>{averageValues.vol_of_fluid.value && formatNumber(averageValues.vol_of_fluid.value)}</td>
                                <td>[{averageValues.vol_of_fluid.value && formatUnit(averageValues.vol_of_fluid.value)}m<sup>3</sup>]</td>
                            </tr>
                            <tr>
                                <td>&#772;y<sub>flow</sub></td>
                                <td>{averageValues.flow.value && formatNumber(averageValues.flow.value)}</td>
                                <td>[{averageValues.flow.value && formatUnit(averageValues.flow.value)}{formatUnit(averageValues.flow.value) === ''? '': ' '}m<sup>3</sup>/h]</td>
                            </tr>
                            <tr>
                                <td>&#772;y<sub>dt1</sub></td>
                                <td>{averageValues.dt1.value && formatNumber(averageValues.dt1.value)}</td>
                                <td>[{averageValues.dt1.value && formatUnit(averageValues.dt1.value)}s]</td>
                            </tr>
                            <tr>
                                <td>&#772;y<sub>dt2</sub></td>
                                <td>{averageValues.dt2.value && formatNumber(averageValues.dt2.value)}</td>
                                <td>[{averageValues.dt2.value && formatUnit(averageValues.dt2.value)}s]</td>
                            </tr>
                            <tr>
                                <td>&#772;y<sub>dt3</sub></td>
                                <td>{averageValues.dt3.value && formatNumber(averageValues.dt3.value)}</td>
                                <td>[{averageValues.dt3.value && formatUnit(averageValues.dt3.value)}s]</td>
                            </tr>
                            <tr>
                                <td>&#772;diff<sub>dt12</sub></td>
                                <td>{averageValues.diffdt12.value && formatNumber(averageValues.diffdt12.value)}</td>
                                <td>[{averageValues.diffdt12.value && formatUnit(averageValues.diffdt12.value)}s]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>soundvelocity1</sub></td>
                                <td>{averageValues.soundvelocity1.value && formatNumber(averageValues.soundvelocity1.value)}</td>
                                <td>[{averageValues.soundvelocity1.value && formatUnit(averageValues.soundvelocity1.value)}m/s]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>soundvelocity2</sub></td>
                                <td>{averageValues.soundvelocity2.value && formatNumber(averageValues.soundvelocity2.value)}</td>
                                <td>[{averageValues.soundvelocity2.value && formatUnit(averageValues.soundvelocity2.value)}m/s]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>soundvelocity3</sub></td>
                                <td>{averageValues.soundvelocity3.value && formatNumber(averageValues.soundvelocity3.value)}</td>
                                <td>[{averageValues.soundvelocity3.value && formatUnit(averageValues.soundvelocity3.value)}m/s]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>re1</sub></td>
                                <td>{averageValues.re1.value && formatNumber(averageValues.re1.value)}</td>
                                <td>[{averageValues.re1.value && formatUnit(averageValues.re1.value)}]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>re2</sub></td>
                                <td>{averageValues.re2.value && formatNumber(averageValues.re2.value)}</td>
                                <td>[{averageValues.re2.value && formatUnit(averageValues.re2.value)}]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>re3</sub></td>
                                <td>{averageValues.re3.value && formatNumber(averageValues.re3.value)}</td>
                                <td>[{averageValues.re3.value && formatUnit(averageValues.re3.value)}]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>temp1</sub></td>
                                <td>{averageValues.temp1.value && formatNumber(averageValues.temp1.value)}</td>
                                <td>[{averageValues.temp1.value && formatUnit(averageValues.temp1.value)}<sup>o</sup>C]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>temp2</sub></td>
                                <td>{averageValues.temp2.value && formatNumber(averageValues.temp2.value)}</td>
                                <td>[{averageValues.temp2.value && formatUnit(averageValues.temp2.value)}<sup>o</sup>C]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>temp3</sub></td>
                                <td>{averageValues.temp3.value && formatNumber(averageValues.temp3.value)}</td>
                                <td>[{averageValues.temp3.value && formatUnit(averageValues.temp3.value)}<sup>o</sup>C]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>temp1</sub></td>
                                <td>{averageValues.temp11.value && formatNumber(averageValues.temp11.value)}</td>
                                <td>[{averageValues.temp11.value && formatUnit(averageValues.temp11.value)}<sup>o</sup>C]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>temp2</sub></td>
                                <td>{averageValues.temp22.value && formatNumber(averageValues.temp22.value)}</td>
                                <td>[{averageValues.temp22.value && formatUnit(averageValues.temp22.value)}<sup>o</sup>C]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>temp3</sub></td>
                                <td>{averageValues.temp33.value && formatNumber(averageValues.temp33.value)}</td>
                                <td>[{averageValues.temp33.value && formatUnit(averageValues.temp33.value)}<sup>o</sup>C]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>density1</sub></td>
                                <td>{averageValues.temp1.value && formatNumber(averageValues.density1.value)}</td>
                                <td>[{averageValues.temp1.value && formatUnit(averageValues.density1.value)}kg/m<sup>3</sup>]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>density2</sub></td>
                                <td>{averageValues.temp2.value && formatNumber(averageValues.density2.value)}</td>
                                <td>[{averageValues.temp2.value && formatUnit(averageValues.density2.value)}kg/m<sup>3</sup>]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>density3</sub></td>
                                <td>{averageValues.temp3.value && formatNumber(averageValues.density3.value)}</td>
                                <td>[{averageValues.temp3.value && formatUnit(averageValues.density3.value)}kg/m<sup>3</sup>]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>density1</sub></td>
                                <td>{averageValues.temp11.value && formatNumber(averageValues.density11.value)}</td>
                                <td>[{averageValues.temp11.value && formatUnit(averageValues.density11.value)}kg/m<sup>3</sup>]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>density2</sub></td>
                                <td>{averageValues.temp22.value && formatNumber(averageValues.density22.value)}</td>
                                <td>[{averageValues.temp22.value && formatUnit(averageValues.density22.value)}kg/m<sup>3</sup>]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>density3</sub></td>
                                <td>{averageValues.temp33.value && formatNumber(averageValues.density33.value)}</td>
                                <td>[{averageValues.temp33.value && formatUnit(averageValues.density33.value)}kg/m<sup>3</sup>]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>viscosity1</sub></td>
                                <td>{averageValues.viscosity1.value && formatNumber(averageValues.viscosity1.value)}</td>
                                <td>[{averageValues.viscosity1.value && formatUnit(averageValues.viscosity1.value)}Pas]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>viscosity2</sub></td>
                                <td>{averageValues.viscosity2.value && formatNumber(averageValues.viscosity2.value)}</td>
                                <td>[{averageValues.viscosity2.value && formatUnit(averageValues.viscosity2.value)}Pas]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>viscosity3</sub></td>
                                <td>{averageValues.viscosity3.value && formatNumber(averageValues.viscosity3.value)}</td>
                                <td>[{averageValues.viscosity3.value && formatUnit(averageValues.viscosity3.value)}Pas]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>viscosity1</sub></td>
                                <td>{averageValues.viscosity11.value && formatNumber(averageValues.viscosity11.value)}</td>
                                <td>[{averageValues.viscosity11.value && formatUnit(averageValues.viscosity11.value)}Pas]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>viscosity2</sub></td>
                                <td>{averageValues.viscosity22.value && formatNumber(averageValues.viscosity22.value)}</td>
                                <td>[{averageValues.viscosity22.value && formatUnit(averageValues.viscosity22.value)}Pas]</td>
                            </tr>
                            <tr>
                                <td>&#772;x<sub>viscosity3</sub></td>
                                <td>{averageValues.viscosity33.value && formatNumber(averageValues.viscosity33.value)}</td>
                                <td>[{averageValues.viscosity33.value && formatUnit(averageValues.viscosity33.value)}Pas]</td>
                            </tr>
                        </tbody>
                    </table>: <Spinner />}
                    </div>:
                null}
                <div className="dashboard-buttons-wrapper">
                    <button className="dashboard-button" onClick={() => navigate('/choice')}>Change Flow Meter</button>
                    <button className="dashboard-button dashboard-button-blue" onClick={handleOpenMeasurementFolder}>Open Measurement Folder</button>
                    <button className="dashboard-button dashboard-button-blue" onClick={handleOpenMeasurementNotes}>Open Measurement Notes</button>
                    {!loadingAverageCalculation?
                        <button className="dashboard-button dashboard-button-blue" onClick={handleCheckAverageValues}>{!isInitialCheckClicked? 'Check': 'Refresh'} Average Values</button>:
                        <button className="dashboard-button dashboard-button-blue"><Spinner size="small" /></button>
                    }
                </div>
            </div>
    )
}

export default DashboardMainTable;
